import styled from "@emotion/styled";
import { useLayoutEffect } from "react";

export const ChatInputTextarea = styled.textarea`
  flex: 1;
  padding: 10px 14px;
  border-radius: 20px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background-color: ${(props) =>
    props.theme.type === "light"
      ? props.theme.gray.gray50
      : props.theme.gray.gray800};
  color: ${(props) => props.theme.text.primary};
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s ease;
  resize: none;
  overflow-y: auto;
  height: 40px;
  box-sizing: border-box;
  max-height: 200px;
  line-height: 20px;
  /* Hide scrollbar but keep scroll functionality */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  &:focus {
    border-color: #5b6bfd;
  }

  &::placeholder {
    color: ${(props) => props.theme.text.secondary};
  }
`;

export function ChatInput({
  value,
  onValueChange,
  onSubmit,
  elementRef,
  ...restProps
}) {
  useLayoutEffect(() => {
    if (elementRef && elementRef.current) {
      elementRef.current.style.height = "auto";
      elementRef.current.style.height = `${elementRef.current.scrollHeight}px`;
    }
  }, [value, elementRef]);

  return (
    <ChatInputTextarea
      onChange={(evt) => {
        onValueChange?.(evt.target.value);
      }}
      placeholder="Ask about your data"
      onKeyDown={(e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          onSubmit(e);
        }
      }}
      rows={1}
      value={value}
      ref={elementRef}
      {...restProps}
    />
  );
}
